<template>
  <el-dialog
    title="添加技师"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="姓名" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="照片" prop="image_id" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload">上传图片</el-button>
          <div v-if="form.image_id != ''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="邮箱" prop="email" :label-width="formLabelWidth">
        <el-input v-model="form.email" autocomplete="off" placeholder="请输入邮箱"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile" :label-width="formLabelWidth">
        <el-input v-model="form.mobile" autocomplete="off" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status" :label-width="formLabelWidth">
        <el-select v-model="form.status" placeholder="请选择状态">
          <el-option label="在职(占用名额)" :value="10"></el-option>
          <el-option label="归档(不占名额)" :value="20"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="从业年限" prop="experience_years" :label-width="formLabelWidth">
        <el-input-number v-model="form.experience_years" :min="0" :max="99" controls-position="right"></el-input-number>
        <span style="margin-left:8px;color:#909399;">年（顾客端展示，0 或留空不展示）</span>
      </el-form-item>
      <el-form-item label="擅长项目" prop="good_at" :label-width="formLabelWidth">
        <el-input v-model="form.good_at" maxlength="100" placeholder="如：深层指压、热石按摩"></el-input>
      </el-form-item>
      <el-form-item label="服务风格" prop="service_style" :label-width="formLabelWidth">
        <el-input v-model="form.service_style" maxlength="100" placeholder="如：专业细致、手法沉稳"></el-input>
      </el-form-item>
      <el-form-item label="个人简介" prop="intro" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="form.intro" maxlength="200" show-word-limit :rows="3" placeholder="顾客端展示的技师介绍，限 200 字"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="form.remark" placeholder="后台内部备注，不展示给顾客"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
      </div>
    </template>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="'image'" @returnImgs="returnImgsFunc">
    </Upload>
  </el-dialog>
</template>

<script>
import TechnicianApi from '@/api/technician/technician.js';
import Upload from '@/components/file/Upload.vue';
export default {
  components: {
    Upload
  },
  data() {
    return {
      form: {
        name: '',
        image_id: '',
        email: '',
        mobile: '',
        status: 10,
        experience_years: 0,
        good_at: '',
        service_style: '',
        intro: '',
        remark: ''
      },
      formRules: {
        name: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }
        ],
        image_id: [
          {
            required: true,
            message: '请上传图片',
            trigger: 'blur'
          }
        ],
        email: [
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ]
      },
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: true,
      loading: false,
      /*是否上传图片*/
      isupload: false,
      file_path: '',
    };
  },
  props: ['open_add'],
  created() {
    this.dialogVisible = this.open_add;
  },
  methods: {
    /**
     * 添加技师
     */
    addUser() {
      let self = this;
      let params = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          TechnicianApi.add(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '添加成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /**
     * 关闭弹窗
     * @param {boolean} e
     */
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          open: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          open: false
        });
      }
    },

    /**
     * 打开上传图片
     */
    openUpload(){
      this.isupload = true;
    },

    /**
     * 上传图片
     * @param {Array} e
     */
    returnImgsFunc(e){
      if (e != null && e.length > 0) {
        this.file_path = e[0].file_path;
        this.form.image_id = e[0].file_id;
      }
      this.isupload = false;
    },

  }
};
</script>

<style>
.img{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/technician/Add.vue